import React, { useState, useEffect } from 'react';

import './TextQuestionTemplate.scss';
import config from '../../../../../config';
import TextAssessmentChip from './TextAssessmentChip';
import { getSectionId } from '../utility';
import { SKIN_ASSESSMENT_QUESTION_TEMPLATE } from '../../../../../common/skinAssessmentConstant';

const TEXT_SINGLE = 'TextSingle';
const TEXT_MULTIPLE = 'TextMultiple';

const TextQuestionTemplate = ({ question, onAnswerSelect, savedAnswerIds = [] }) => {

    const [selected, setSelected] = useState([]);

    const isMultiple = question?.question_type === TEXT_MULTIPLE;
    const minAnswer = isMultiple ? (Number(question?.minimum_answer) || 1) : 1;
    const questionLabel = getSectionId(question?.question_label);
    const titleClassName = SKIN_ASSESSMENT_QUESTION_TEMPLATE[questionLabel]?.qTitleBgClassName;
    const selectedClass = SKIN_ASSESSMENT_QUESTION_TEMPLATE[questionLabel]?.selectedClassName;

    useEffect(() => {
        if (savedAnswerIds.length) {
            const selectedOption = question.question_value.filter(opt => savedAnswerIds.includes(opt._id));

            setSelected(selectedOption);
        } else {
            setSelected([]);
        }
    }, [question, savedAnswerIds]);

    const toggleOption = (option) => {
        let updated = [];

        if (isMultiple) {
            if (selected.some(item => item._id === option._id)) {
                updated = selected.filter(item => item._id !== option._id);
            } else {
                updated = [...selected, option];
            }
        } else {
            if (selected[0]?._id === option._id) {
                return;
            }
            updated = [option];
        }
        setSelected(updated);
        const canProceed = !isMultiple || updated.length >= minAnswer;
        onAnswerSelect({ canGoNext: canProceed, nextLabel: null, question_id: question._id, question_label: question.question_label, answer_ids: updated.map(item => item._id) });
    };

    return (
        <div className="skin-chips-container">
            <div className={`skin-chip-question ${titleClassName}`}>
                {question?.question}{question?.description ? <><br /><span className={`skin-chip-question-span`}>{question?.description}</span></> : null}
            </div>
            <div className="skin-chip-image">
                {question?.image_url && <img src={`${config.S3_URL}${question?.image_url}`} alt='' />}
            </div>
            <div className="skin-chip-question-value">
                {question?.question_value.map((chip, index) => (
                    <>
                        <TextAssessmentChip
                            key={chip?._id || index}
                            text={chip?.value}
                            isSelected={selected.some(option => option._id === chip._id)}
                            onClick={() => toggleOption(chip)}
                            selectedClass={selectedClass}
                        />
                    </>
                ))}
            </div>
        </div>
    );
};

export default TextQuestionTemplate;